import sheltersMapList from '@/store/modules/shelters-map/shelters-map-list'
import sheltersMapDelete from '@/store/modules/shelters-map/shelters-map-delete'
import sheltersMapCreate from '@/store/modules/shelters-map/shelters-map-create'
import shelterMap from '@/store/modules/shelters-map/shelter-map'

export default {
  shelterMap,
  sheltersMapList,
  sheltersMapDelete,
  sheltersMapCreate,
}
